import { StringBundle } from '../localizer/stringBundle'

export const strings = {
  bundles: [StringBundle.ATF, StringBundle.BTF],
  strings: [
    'DV_TW_title_starring',
    'DV_TW_title_actors',
    'DV_TW_title_producers',
    'DV_TW_title_genres',
    'DV_TW_title_subtitles',
    'DV_TW_title_languages',
    'DV_TW_title_directors',
    'DV_TW_title_studio',
    'DV_TW_title_network',
    'DV_TW_title_seasonyear',
    'DV_TW_title_amr',
    'DV_TW_title_content_descriptors',
    'DV_DP_learn_more',
    'DV_DP_ARIA_learn_more_amr',
    'DV_comma_separator',
    'DV_TW_title_purchaserights',
    'DV_TW_title_devices',
    'DV_TW_data_available_to_watch_devices',
    'DV_TW_data_purchaserights_streaming',
    'DV_TW_Detail_text',
    'DV_TW_title_format',
    'DV_TW_data_format_streaming',
    'DV_TW_title_mpaarating',
    'DV_TW_title_bbfcrating',
    'DV_TW_title_fskrating',
    'DV_TW_title_eirinrating',
    'DV_DP_more_details',
    'DV_DP_more_items',
    'DV_brand_av',
    'DV_WEB_DP_popover_purchase_rights',
  ] as const,
}
